import {
  CREATE_SCHEDULE_PENDING,
  CREATE_SCHEDULE_FAIL,
  CREATE_SCHEDULE_SUCCESS,
  UPDATE_SCHEDULE_PENDING,
  UPDATE_SCHEDULE_FAIL,
  UPDATE_SCHEDULE_SUCCESS,
  GET_SCHEDULES_PENDING,
  GET_SCHEDULES_FAIL,
  GET_SCHEDULES_SUCCESS,
  CLEAR_SCHEDULES_STORE,
} from '../actions/scheduleActions';


const initialState = {
  schedule: {
    loading: false,
    loaded: true,
    id: null,
    account: null,
    name: '',
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    exclude_us_holidays: false,
    time_from: null,
    time_to: null,
    is_primary: false,
  },
  schedules: {
    loading: true,
    loaded: false,
    results: [],
  },
};


export const scheduleReducer = (state = initialState.schedule, action) => {
  switch (action.type) {
    case CREATE_SCHEDULE_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_SCHEDULE_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_SCHEDULE_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_SCHEDULE_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case UPDATE_SCHEDULE_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_SCHEDULE_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};


export const schedulesReducer = (state = initialState.schedules, action) => {
  switch (action.type) {
    case CLEAR_SCHEDULES_STORE:
      return {
        loading: false,
        loaded: true,
      };
    case GET_SCHEDULES_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case GET_SCHEDULES_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_SCHEDULES_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};
